import { Icon, Stack, useTheme } from "@fluentui/react";
import React, { useEffect } from "react";
import { getAepPayloadContentType } from "../../../externalApi/AepApi";
import { requestRefresh } from "../../../externalApi/DashboardHostApi";
import { isAppVersionBlocked, isOSVersionBlocked, isWVVersionBlocked } from "../../../externalApi/DashboardHostApiInternal";
import { addVisibilityEventListeners, getIsWindowVisible, getLastShowReason, removeVisibilityEventListeners } from "../../../externalApi/WindowApi";
import { getResources } from "../../../getResources";
import { formatString } from "../../../utils/stringUtilities";
import { Button } from "../../generic/Button/Button";
import { Grid } from "../../generic/Grid/Grid";
import { Text } from "../../generic/Text/Text";
import { getButtonStyle, getTempDisablementPageStyle, getVersionComponentIconStyle } from "./TempDisablementPage.styles";
import { VersionComponentTextContainer } from "./VersionComponentTextContainer/VersionComponentTextContainer";
import { logPageEvent, logPageHidden, logPageShown } from "../Telemetry/PageTelemetry";
const TempDisablementPage = (props) => {
    const theme = useTheme();
    const handleWindowShown = async () => {
        let aepPayloadContentType = await getAepPayloadContentType();
        let lastShowReason = await getLastShowReason();
        logPageShown("temp-disablement", aepPayloadContentType, lastShowReason);
    };
    const handleWindowHidden = () => {
        logPageHidden("temp-disablement");
    };
    useEffect(() => {
        logPageEvent("temp-disablement");
        addVisibilityEventListeners(handleWindowShown, handleWindowHidden);
        // If the Window is visible fire the visibility event since we will have missed the first on on cold launch.
        getIsWindowVisible().then((visible) => {
            if (visible) {
                handleWindowShown();
            }
        }, (reason) => {
            // If windowAPI is unavailable do nothing
        });
        return () => {
            removeVisibilityEventListeners(handleWindowShown, handleWindowHidden);
        };
    }, []);
    return (React.createElement("div", { onClick: (e) => { var _a; return (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e); }, style: { height: "100%" } },
        React.createElement(Stack, { id: "temp-disablement", horizontalAlign: "center", verticalAlign: "center", styles: getTempDisablementPageStyle() },
            React.createElement(Text, { variant: "xxLarge", marginBottom: "12px" }, getResources().TempDisablementPage_Header),
            React.createElement(Text, { variant: "medium", marginBottom: "28px" }, formatString(getResources().TempDisablementPage_SubText)),
            isAppVersionBlocked() && React.createElement(VersionComponentTextContainer, { marginBottom: 8 },
                React.createElement(Icon, { id: "AppVer", iconName: "OfficeStoreLogo", styles: getVersionComponentIconStyle(theme) }),
                React.createElement("a", { href: "ms-windows-store://pdp/?productid=9mssgkg348sp" },
                    " ",
                    getResources().TempDisablementPage_Component_Text_1,
                    " ")),
            isOSVersionBlocked() && React.createElement(VersionComponentTextContainer, { marginBottom: 8 },
                React.createElement(Icon, { id: "OSVer", iconName: "Settings", styles: getVersionComponentIconStyle(theme) }),
                React.createElement("a", { href: "ms-settings:windowsupdate" },
                    " ",
                    getResources().TempDisablementPage_Component_Text_2,
                    " ")),
            isWVVersionBlocked() && React.createElement(VersionComponentTextContainer, { marginBottom: 8 },
                React.createElement(Icon, { id: "WebViewVer", iconName: "ReopenPages", styles: getVersionComponentIconStyle(theme) }),
                React.createElement("a", { href: "https://developer.microsoft.com/en-us/microsoft-edge/webview2/consumer/" },
                    " ",
                    getResources().TempDisablementPage_Component_Text_3,
                    " ")),
            React.createElement(Grid, { tokens: { columns: 1 } },
                React.createElement(Button, { id: "temp-disablement-refresh-button", onClick: () => requestRefresh(), styles: getButtonStyle() }, getResources().TempDisablementPage_RefreshButtonText)))));
};
export default TempDisablementPage;
